import { withStyles, withTheme } from "@material-ui/core/styles";
import { useState } from "react";
import { compose } from "recompose";
import { AppLoading } from "../../loaders/loaders";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";

const styles = theme => ({
  card: {
    flex:1,
    maxWidth: "100%",
    maxHeight: "100%",
  },
  media: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    border: "0px"
  },
  moduleNotAvailbale:{
    color:theme.HeaderSelectedText,
  },
  hidden: {
    display: "none"
  }
});

const IFrameRenderer = (props) => {
  const [loading, setLoading] = useState(Boolean(props.url));
  const visible = props.visible !== false; // Default to true if not provided

  const handleLoad = () => {
    setLoading(false);
  };

  if (props.url) {
    return (
      <Card 
        className={`${props.classes.card} ${!visible ? props.classes.hidden : ''}`} 
        elevation={0} 
        key={props.url}
      >
        {loading && <AppLoading />}
        <CardMedia
          component="iframe"
          className={props.classes.media}
          src={props.url}
          onLoad={handleLoad}
        />
      </Card>
    );
  } else {
    return <div className={props.classes.moduleNotAvailbale}>URL Not Found</div>;
  }
};

export default compose(withStyles(styles), withTheme())(IFrameRenderer);
